import { render, staticRenderFns } from "./SidebarSocials.vue?vue&type=template&id=f6019b06&scoped=true&"
import script from "./SidebarSocials.vue?vue&type=script&lang=js&"
export * from "./SidebarSocials.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSocials.vue?vue&type=style&index=0&id=f6019b06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6019b06",
  null
  
)

export default component.exports